import React from 'react';
import groupDiscussion from "../../../assets/images/groupDiscussion.png";

const GdEndWait = () => {
  return (
    <div className="flex flex-1 flex-col justify-center items-center h-full">
      <img
        src={groupDiscussion}
        alt="Group Discussion"
        className="object-contain mb-4"
        style={{ height: '20%', width: '35%' }}
      />
      <span
        className="text-white text-center text-sm"
        style={{
          padding: '1.5%',
          fontFamily: "'Lato', sans-serif",
          width: '60%',
          marginBottom: 0,
          paddingBottom: 0,
        }}
      >
        Group Discussion ended
      </span>
      <span
        className="text-white text-center text-base"
        style={{
          padding: '1.5%',
          paddingTop: 0,
          fontFamily: "'Lato', sans-serif",
          width: '60%',
          marginBottom: '1%',
        }}
      >
        Standby for further instructions from Trainer
      </span>
    </div>
  );
};

export default GdEndWait;